// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import common from "@store/Themes/common/styleguide/components/forms/radio";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const radio: Styleguide["radio"] = {
    defaultProps: {
        ...common,
        css: css<any>`
            ${common?.defaultProps?.css}
            input {
                position: absolute;
                clip: rect(0, 0, 0, 0);

                &:focus {
                    clip: unset;
                }

                & + label {
                    margin: 0;
                    cursor: pointer;

                    &::before {
                        height: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 16 : 20)}px;
                        width: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 16 : 20)}px;
                        border-width: ${pxToRem(1)};
                        margin-right: 0.7em;
                        flex-shrink: 0;
                    }

                    &:hover::before {
                        border-color: ${getColor("secondary")};
                    }
                }

                &:focus + label::before {
                    box-shadow: 0 0 0 ${pxToRem(2)} ${getProp("theme.focus.color")};
                }

                &:checked:not(:disabled) + label::before {
                    border-color: ${getColor("secondary")};
                    background: ${getColor("common.background")};
                }

                &:checked + label::after {
                    content: "";
                    display: block;
                    height: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 6 : 10)}px;
                    width: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 6 : 10)}px;
                    border-radius: 50%;
                    background: ${getColor("secondary")};
                    position: absolute;
                    left: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 4 : 5)}px;
                    top: calc(50% - ${({ _sizeVariant }) => (_sizeVariant === "small" ? 3 : 5)}px);
                }

                &:checked:disabled,
                &:disabled {
                    & + label::before {
                        border-color: ${getColor("common.disabled")};
                    }

                    & + label::after {
                        background: ${getColor("common.disabled")};
                    }
                }
            }
        `,
    },
};

export default radio;
